import React, { useEffect, useState, useRef, forwardRef } from 'react';
import api, { exceptionNotificationAPI } from '../../services/api';
import { Box, InputBase, InputAdornment, Button, Content } from '@material-ui/core';
import { useStyles } from './styles';
import { useLocation, useHistory } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import TableLoading from '../TableLoading';
import moment from 'moment';
import MenuTableEditRemove from '../MenuTableEditRemove';
import DatePicker, { registerLocale } from 'react-datepicker';
import DateRangeIcon from '@mui/icons-material/DateRange';
import { error_message, success_message } from '../Toast/index.jsx';
import { Col, Row } from 'react-bootstrap';
import { Container } from '@mui/material';
import ModalConfirmClone from '../ModalConfirmClone';
import Swal from 'sweetalert2';

const TotalsAnalyseSampleList = () => {
    const history = useHistory();
    const styles = useStyles();
    var today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    const [isLoading, setIsLoading] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [endDate, setEndDate] = useState(lastDay);
    const [startDate, setStartDate] = useState(firstDay);
    const [list, setList] = useState([]);
    const [tenants, setTenants] = useState([]);
    const [selectedTenant, setSelectedTenant] = useState();

    useEffect(() => {
        let cancel = false;

        
        

        setStartDate(firstDay);
        setEndDate(lastDay);

        setIsLoading(true)

        if (cancel) return

        loadAllTenants((optionsTenants) => {
            if (cancel) return
            if (optionsTenants)
            {
                setTenants(optionsTenants)                
            }
        });

        

        loadTable((response) => {
            if (cancel) return
            setList(response)
            setIsLoading(false)
        });

        return () => {
            cancel = true;
            setIsLoading(false)
        }
    }, []);         

    if (isLoading) {
        return (
            <TableLoading />
        )
    }

    const loadAllTenants = async (callback) => {
        api.get('Tenant/getAllItems').then((result) => {
            if (result && result.data) {
                const options = result.data.response;

                callback(options);
                //setIsLoading(false)
            }
        }).catch((error) => {
            exceptionNotificationAPI(error);
        });
    }

    const loadTable = async (callback) => {

        console.log('-----------------' + startDate)

        api.get(`TotalsAnalyseSample/GetAnalysisSampleTotals?id=${selectedTenant ? selectedTenant : "00000000-0000-0000-0000-000000000000"}
                &&startDate=${startDate ? moment(startDate).format("MM/DD/yyyy") : ""}
                &&endDate=${endDate ? moment(endDate).format("MM/DD/yyyy") : ""}`).then((result) => {
            if (result && result.data && result.data.response) {

                const options = result.data.response.data                
                

                callback(options);
            }
        }).catch((error) => {
            exceptionNotificationAPI(error);
        });
    }

    const InputDate = forwardRef(({ value, onClick }, ref) => (
        <InputBase ref={ref} className={styles.search} placeholder={"Período"} style={{ background: "white", marginLeft: 30, paddingRight: 20 }} value={value} onClick={onClick}
            startAdornment={
                <InputAdornment position="start">
                    <DateRangeIcon htmlColor='#5A646E' />
                </InputAdornment>
            }
        />
    ));
    

    return (

        <Box className={styles.container} >
            <Box className={styles.block2} style={{ margin: '0 auto', paddingLeft: 0, marginTop: '25px', width: '80%' }} >
                <label style={{ fontFamily: "Montserrat", fontWeight: 700, fontSize: 24, paddingTop: '17px', color: "#161C24" }} >Totais de Interpretações</label>
            </Box>

            
            <div className={styles.block2} style={{ margin: '0 auto', marginTop: '25px', padding: '20px', width: '80%', backgroundColor: 'white', borderRadius: '8px', justifyContent: "flex-start", }} >
                <Box className={styles.block1} style={{ margin: '0 auto', paddingLeft: 0, marginTop: '25px', width: '100%' }} >
                    <Col>
                        <Box style={{ width: "300px" }}  >
                            <DatePicker
                                locale={"ptBR"}
                                dateFormat={"dd/MM/yyyy"}
                                customInput={<InputDate />}
                                selectsRange
                                startDate={startDate}
                                endDate={endDate}
                                selected={startDate}
                                onChange={(dates) => {
                                    const [start, end] = dates;
                                    console.log(start)
                                    console.log(end)
                                    setStartDate(start);
                                    setEndDate(end);
                                }}
                                isClearable={true}
                            />
                        </Box>
                    </Col>
                    {
                        tenants && tenants.length == 1 ? (
                        <>
                        
                        </>
                        ) : (
                                    <Col>
                                        <select name='id' value={selectedTenant}  onChange={(e) => { setSelectedTenant(e.target.value) }} 
                                        style={{ border: "1px solid rgba(145, 158, 171, 0.32)", padding: '5px', marginLeft: "2%", width: "300px", marginRight: "2%",  }} className={styles.fieldResponsible}>
                                            <option value="00000000-0000-0000-0000-000000000000">Todos os Tenants</option>
                                            {tenants && tenants.map((option) => <option key={option.tenantID} value={option.tenantID}>{option.name}</option>)}                    
                                        </select>
                                    </Col>
                        )}
                    <Col>
                        <Button className={styles.button} style={{ marginLeft: "10px" }}
                            onClick={() => {
                                setIsLoading(true)
                                
                                loadTable((response) => {                            
                                    setList(response)
                                    setIsLoading(false)
                                }, true)
                            }}
                        >
                            Buscar
                        </Button>
                    </Col>
                </Box>
            </div>
               
            
            
            
            <div className={styles.block2} style={{ margin: '0 auto', marginTop: '25px', padding: '20px', width: '80%', backgroundColor: 'white', borderRadius: '8px', justifyContent: "center" }} >
                    {
                        list.length>0
                        ?
                        list.map(e => {
                            return (
                                <Box style={{ justifyContent: "center", width: '100%' }}>
                                    <div className={styles.block1} style={{ padding: '10px', margin: '10px',width: '100%', fontSize: "15px", backgroundColor: '#0C8662', borderRadius: '8px', textAlign: 'left' }} >                                        
                                        <div  style={{ fontFamily: "Montserrat", fontWeight: 600, fontSize: 16, color: "#FFFFFF" }} >{e.tenantName}</div>
                                    </div>
                                    <div className={styles.block1} style={{ justifyContent: "center", width: '100%' }}>
                                        <Box className={styles.block2} style={{ padding: '10px', margin: '10px',width: '25%', height: '150px', fontSize: "17px", backgroundColor: '#9FD0B7', borderRadius: '8px', textAlign: 'center' }} >
                                            <Box style={{ fontWeight: 'bold'}}>Total de amostras Integradas</Box>
                                            <Box style={{ fontWeight: 'bold', fontSize:'50px', marginTop:'10px'}}>{e.totalIntegrated}</Box>
                                        </Box>
                                        <Box className={styles.block2} style={{ padding: '10px', margin: '10px', width: '25%', height: '150px', fontSize: "17px", backgroundColor: '#79C199', borderRadius: '8px', textAlign: 'center' }} >
                                            <Box style={{ fontWeight: 'bold'}}>Total de amostras Manuais</Box>
                                            <Box style={{ fontWeight: 'bold', fontSize:'50px', marginTop:'10px'}}>{e.totalManual}</Box>
                                        </Box>
                                        <Box className={styles.block2} style={{ padding: '10px', margin: '10px', width: '25%', height: '150px', fontSize: "17px", backgroundColor: '#EC642C', borderRadius: '8px', textAlign: 'center' }} >
                                            <Box style={{ fontWeight: 'bold'}}>Total</Box>
                                            <Box style={{ fontWeight: 'bold', fontSize:'50px', marginTop:'10px'}}>{e.total}</Box>
                                        </Box>
                                    </div>
                                </Box>

                                
                            )
                            
                        })
                        : 
                        <Box style={{ justifyContent: "center", width: '100%' }}>
                            <div className={styles.block1} style={{ padding: '30px', margin: '10px',width: '100%', fontSize: "15px", backgroundColor: '#9FD0B7', borderRadius: '8px', textAlign: 'center' }} >                                        
                                <div  style={{ fontFamily: "Montserrat", fontWeight: 600, fontSize: 16, color: "Black" }} >Não há registros para o período e Tenant selecionado.</div>
                            </div>                            
                        </Box>
                    }      
                    
             </div>
        </Box >
    );
}
export default TotalsAnalyseSampleList;
